import React, {
	PureComponent,
	Fragment
} from "react";
import {
	View,
	StyleSheet,
	TextInput,
	Platform
} from "react-native";

import InputContainer from "./Layout/InputContainer";
import StyledIconButton from "ae-base/Base/StyledIconButton";

import Style from "ae-style";

var styles = StyleSheet.create({
	container: {
		backgroundColor: Style.look.sectionBackground,
		borderColor: Style.look.sectionOutline,
		borderWidth: 1,
		flexDirection: "row"
	},
	input: {
		flex: 1
	},
	searchIcon: {
		paddingHorizontal: Style.layout.paddingSlim
	},
	clearIcon: {
		padding: Style.layout.paddingButton
	}
});

export default class SearchBox extends PureComponent {
	constructor(props){
		super(props);
		var defaultValue = props.defaultValue || "";
		this.state = {
			textLength: defaultValue.length
		};

		this._textInput = null;
		this.setRef = setRef.bind(this);
		this.onClear = onClear.bind(this);
		this.onChangeText = onChangeText.bind(this);
	}

	render(){
		var props = this.props;
		var renderClearButton = this.state.textLength ? (
			<View style={styles.clearIcon}>
				<StyledIconButton id={props.id + "_clear"} icon="times-circle" onPress={this.onClear} standard />
			</View>
		) : null;

		const formContent = Platform.OS === "web" ? (
			<form onSubmit={(e) => {e.preventDefault();}}>
				<View style={styles.container}>
						<View style={styles.searchIcon}>
							<StyledIconButton id={props.id + "_submit"} icon="search" onPress={props.onSubmit} />
						</View>
						<TextInput
							accessibilityRole="search"
							accessibilityLabel="Search Box"
							autoComplete="off"
							style={[styles.input, props.textStyle]}
							ref={this.setRef}
							onChangeText={this.onChangeText}
							defaultValue={props.defaultValue} />
						{renderClearButton}
					</View>
			</form>) : (
			<View style={styles.container}>
				<View style={styles.searchIcon}>
					<StyledIconButton id={props.id + "_submit"} icon="search" onPress={props.onSubmit} />
				</View>
				<TextInput
					accessibilityRole="search"
					accessibilityLabel="Search Box"
					autoComplete="off"
					style={styles.input}
					ref={this.setRef}
					onChangeText={this.onChangeText}
					defaultValue={props.defaultValue} />
				{renderClearButton}
			</View>);

		return (
			<InputContainer>
				{formContent}
			</InputContainer>
		);
	}
}

function onChangeText(text){
	this.setState({
		textLength: text.length
	});
	if(this.props.onChange) this.props.onChange(text);
}

function onClear(){
	if(this._textInput) this._textInput.clear();
	this.setState({
		textLength: 0
	});
	if(this.props.onChange) this.props.onChange("");
}

function setRef(component){
	this._textInput = component;
}